import React from 'react';
export function EstoEsParaVosSection() {
  return <section className="relative w-full text-white" style={{
    backgroundImage: "url('https://res.cloudinary.com/dd0wtuekk/image/upload/v1771285256/Kk_rxxiy7.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '60px 20px'
  }} data-id="element-51">
      {/* Dark overlay */}
      <div className="absolute inset-0" style={{
      background: 'rgba(0,0,0,0.65)'
    }} data-id="element-52" />

      <div className="relative z-10 max-w-[600px] mx-auto" data-id="element-53">
        <h2 className="font-extrabold text-center" style={{
        fontSize: '22px',
        marginBottom: '24px'
      }} data-id="element-54">
          ESTO ES PARA VOS SI…
        </h2>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[500]" data-id="element-55">
          ❌ Te duele ver cómo tu hijo se paraliza en los partidos importantes…
          aunque sabés que tiene talento de sobra.
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-56">
          ❌ Te frustra verlo jugar con miedo, dudar antes de pedir la pelota,
          achicarse en momentos clave.
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-57">
          ❌ Te preocupa ver cómo otros chicos avanzan… mientras el tuyo se
          queda atrás, no por falta de capacidad, sino por falta de confianza.
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-58">
          ❌ Sabés que entrena, que se esfuerza, que quiere mejorar… pero su
          propia cabeza lo traiciona en el partido.
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-59">
          ❌ Te angustia pensar que si sigue perdiendo seguridad, un día puede
          empezar a creer que no es lo suficientemente bueno.
        </p>

        <p style={{
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-60">
          ❌ Te parte verlo darlo todo en la semana… y que el domingo no pueda
          demostrar nada de lo que sabe hacer.
        </p>
      </div>
    </section>;
}